import React,{ Component } from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import Button from '../../../shared/components/Button';

//TODO: Fix this awful mispelling...
import AgencyManageAccountInfo from '../../AgencyManageAccoutInfo';
import AgencyManageAccountTeam from '../../AgencyManageAccoutTeam';

class AgencyManageAccount extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      error:null
    };
  }

  componentDidMount(){
    Promise
      .all([])
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  render(){
    const { match } = this.props;

    return (
      <div className='AgencyManageAccount'>
        <Container>
          <Row className='EntityList-title'>
            <Col xs='6'>
              <h1>Manage Account</h1>
            </Col>
            <Col xs='6'>
              <div className='pull-right'>
                <Switch>
                  <Route
                    exact path={`${match.url}/paymentmethods`}
                    render={() => (
                      <Button linkHref={`${match.url}/paymentmethods/new`}>
                        Add Payment Method
                      </Button>
                    )}
                  />
                  <Route
                    exact path={`${match.url}/users`}
                    render={() => (
                      <Button linkHref={`${match.url}/users/new`}>
                        Invite User
                      </Button>
                    )}
                  />
                  <Route
                    exact path={`${match.url}/billing`}
                    render={() => (
                      <Button linkHref={`${match.url}/billing/new`}>
                        Add Funds
                      </Button>
                    )}
                  />
                </Switch>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs='12'>
              <Nav tabs className='UnderLineTabs'>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to={`${match.url}/info`}
                    activeClassName='active'
                  >
                    Info
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to={`${match.url}/users`}
                    activeClassName='active'
                  >
                    Team
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to={`${match.url}/paymentmethods`}
                    activeClassName='active'
                  >
                    Payment
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to={`${match.url}/billing`}
                    activeClassName='active'
                  >
                    Billing
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
          </Row>
          <br />
          <Switch>
            <Route path={`${match.url}/info`} component={AgencyManageAccountInfo} />
            {/*TODO: Add Edit User and Invite User*/}
            <Route path={`${match.url}/users`} component={AgencyManageAccountTeam} />
          </Switch>
        </Container>
      </div>
    );
  }
}

AgencyManageAccount.propTypes = {};

AgencyManageAccount.defaultProps = {};

export default AgencyManageAccount;



// WEBPACK FOOTER //
// ./src/routes/AgencyManageAccount/components/AgencyManageAccount.js